<template>
    <div class="details_container">
        <div class="top_box">
            <div class="time_container">
                <div class="sel_time" :class="{'time': startTime}" @click=" isStartTimeShow = true">{{startTime ? startTime : '起始时间'}}</div>
                <div class="center_line"></div>
                <div class="sel_time" :class="{'time': endTime}" @click="isEndTimeShow = true">{{endTime ? endTime : '结束时间'}}</div>
            </div>
            <div class="switch" @click="switchBtn">
                {{isForms ? '报表' : '曲线' }} 
            </div>
        </div>
        <div class="data_container">
            <!-- 报表 -->
            <table v-show="isForms" class="table_box">
                <tr class="table_title">
                    <th>日期</th>
                    <th>收益</th>
                    <th>访客</th>
                </tr>
                
                <tr class="item_data" :class="{'first_item_data': index == 0}" v-for="(item, index) in 6" :key="index">
                    <!-- <td>11月1日</td>
                    <td>666</td>
                    <td>108</td> -->
                    <!-- <td>{{tableData.incomeList[index].dateTime}}</td>
                    <td>{{tableData.incomeList[index].income}}</td>
                    <td>{{ableData.visitList[index].num}}</td> -->
                </tr>
            </table>
            <!-- 曲线 -->
            <div v-show="!isForms">
                <!-- 收益数据 -->
                <div class="curve_container">
                    <h2 class="title">收益数据</h2>
                    <div class="curve_box" id="earnings"></div>
                </div>
                <!-- 访客数据 -->
                <div class="curve_container">
                    <h2 class="title">访客数据</h2>
                    <div class="curve_box" id="visitor"></div>
                </div>
            </div>
        </div>
        <van-calendar 
            :min-date="startMinDate"
            :max-date="startMaxDate"
            :default-date="startTimeStamp ? startTimeStamp : ''"
            v-model="isStartTimeShow" 
            @confirm="startTimeConfirm" />
        <van-calendar 
            :min-date="endMinDate"
            :max-date="endMaxDate"
            :default-date="endTimeStamp ? endTimeStamp : ''"
            v-model="isEndTimeShow" 
            @confirm="endTimeConfirm" />
    </div>
</template>
<script>
import * as echarts from "echarts";
import { getExpertDataCenterApi } from "@/api/expert";
export default {
    data() {
        return {
            tableData: {},
            isForms: true,
            isStartTimeShow: false, // 开始日历选择是否显示
            isEndTimeShow: false, // 结束日历选择是否显示
            startTime: '2023-1-1', // 开始时间
            endTime: '2023-1-7',// 结束时间
            startTimeStamp: new Date('2023-1-1'), // 默认开始时间戳
            endTimeStamp: new Date('2023-1-7'), // 默认结束时间戳
            startMinDate: new Date('2023-1-1'),
            startMaxDate: new Date(new Date().setDate((new Date().getDate()-6))),
            endMinDate: new Date('2023-1-7'),
            endMaxDate: new Date(),
            myChart: {},
            xData: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //横坐标
            yData: [23, 24, 18, 25, 27, 28, 25], //人数数据
        };
    },
    methods: {
        // 获取行家数据中心
        getExpertDataCenter() {
            getExpertDataCenterApi({
                startTime: this.startTime + ' 00:00:00',
                endTime: this.endTime + ' 59:59:59'
            }).then((res) => {
                if (res.appStatus.errorCode == 0) {
                    this.tableData = res.content
                    console.log(res.content)
                    this.$nextTick(()=>{
                        this.initEarningsEcharts();
                        this.initVisitorEcharts();
                    })
                }
            });
        },
        // 起始时间
        startTimeConfirm(data) {
            this.isStartTimeShow = false
            this.startTimeStamp = new Date(data)
            this.startTime = this.dealTime(data)
            // this.startMinDate = data
            this.endMaxDate = new Date(data.setDate(data.getDate()+6))
            this.endTime = this.dealTime(this.endMaxDate)
        },
        // 结束时间
        endTimeConfirm(data) {
            this.isEndTimeShow = false
            this.endTimeStamp = new Date(data)
            this.endTime = this.dealTime(data)
            this.startTimeStamp = new Date(data.setDate(data.getDate() - 6))
            this.startTime = this.dealTime(this.startTimeStamp)
        },
        // 处理时间格式
        dealTime(data) {
            let char = "-";
            if(data == null){
                data = new Date();
            }
            let day = data.getDate();
            let month = data.getMonth() + 1;//注意月份需要+1
            let year = data.getFullYear();
            //补全0，并拼接
            return year + char + month + char + day;
        },
        switchBtn() {
            this.isForms = !this.isForms
            // if(!this.isForms) {
            //     console.log('222')
            //     this.$nextTick(()=>{
            //         this.initEarningsEcharts();
            //         this.initVisitorEcharts();
            //     })
                
            // }
        },
        // 收益数据
        initEarningsEcharts() {
            const option = {
                xAxis: {
                    type:'category',
                data: this.xData
                },
                yAxis: {
                    type:'value'
                },
                series: [
                {
                    data: this.yData,
                    type: "line" // 类型设置为折线图
                }
                ]
            };
            echarts.init(document.getElementById("earnings")).setOption(option)
        },
        // 访客数据
        initVisitorEcharts() {
            const option = {
                xAxis: {
                    type:'category',
                data: this.xData
                },
                yAxis: {
                    type:'value'
                },
                series: [
                {
                    data: this.yData,
                    type: "line" // 类型设置为折线图
                }
                ]
            };
            echarts.init(document.getElementById("visitor")).setOption(option)
        },
    },
    mounted() {
        this.getExpertDataCenter()
    }
};
</script>
<style lang="scss" scoped>
    .details_container {
        width: 100vw;
        min-height: calc(100vh - 46px);
        padding: 10px 15px 25px;
        box-sizing: border-box;
        background-color: #fff;
        .top_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .time_container {
                display: flex;
                justify-content: center;
                align-items: center;
                .center_line {
                    width: 11px;
                    height: 1px;
                    background: #DFDFDF;
                    margin: 0 10px;
                }
                .sel_time {
                    width: 120px;
                    height: 35px;
                    background: #F6F6F6;
                    border-radius: 50px;
                    text-align: center;
                    line-height: 35px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #999999;
                }
                .time {
                    color: #333333;
                }
            }
            .switch {
                font-size: 14px;
                color: #333333;

            }
        }
        .data_container {
            width: 100%;
            min-height: calc(100% - 20px - 37px);
            background-color: #fff;
            margin-top: 20px;
            // background-color: pink;
            // 表格
            .table_box {
                width: 100%;
                font-size: 14px;
                border-collapse: collapse;
                border-radius: 12px;
                .table_title {
                    height: 40px;
                    background-color: #FFEFDA;
                    font-size: 15px;
                    color: #A76539;
                    font-weight: 400;
                    border: 1px solid #FFEFDA;
                }
                .item_data {
                    text-align: center;
                    color: #333333;
                    font-size: 14px;
                    td {
                        border: 1px solid #E5E5E5;
                        line-height: 40px;
                    }
                }
                .first_item_data {
                    td {
                        border-top: none;
                    }
                }
            }
            .curve_container {
                .title {
                    font-size: 15px;
                    font-weight: bold;
                    color: #333333;
                }
                .curve_box {
                    background-color: #fff;
                    width: 100%;
                    height: 400px;
                    margin: 20px 0;
                    border-radius: 12px;
                    border: 1px solid #E5E5E5;
                    padding: 20px 15px;
                    box-sizing: border-box;
                
                }
            }
        }
    }
</style>